<template>
  <div class="centralizadohorizontal">
    <div class="estiloColuna">
      <v-card elevation="2" outlined style="margin-top:1%;height:95%;overflow-y:auto;">

        <v-card-title class="pb-1 pt-3" style="font-size:1.25rem;">
          <v-icon left color="primary">mdi-tune</v-icon>
          Configuração Omie
        </v-card-title>
        <v-card-subtitle class="pb-2" style="margin-top:3px;">Integração com a plataforma Omie para sincronização de estoque</v-card-subtitle>

        <v-divider />

        <!-- Status -->
        <div class="px-5 pt-4 pb-2">
          <v-chip
            v-if="!carregando"
            small
            :color="config.appKeyConfigurado ? 'success' : 'warning'"
            text-color="white"
            class="font-weight-medium"
          >
            <v-icon left x-small>{{ config.appKeyConfigurado ? 'mdi-check-circle' : 'mdi-alert-circle' }}</v-icon>
            {{ config.appKeyConfigurado ? 'Integração configurada' : 'Credenciais não configuradas' }}
          </v-chip>
          <v-skeleton-loader v-else type="chip" width="200" />
        </div>

        <!-- Credenciais -->
        <v-card flat class="mx-4 mb-4 mt-2" outlined>
          <v-card-text>
            <div class="d-flex align-center justify-space-between mb-4">
              <span class="subtitle-2 text--secondary">
                <v-icon small class="mr-1" style="vertical-align:middle;">mdi-shield-key-outline</v-icon>
                Credenciais de acesso
              </span>
              <div v-if="!modoEdicao">
                <v-btn small outlined color="primary" @click="iniciarEdicao" :disabled="carregando">
                  <v-icon left small>mdi-pencil</v-icon>
                  Editar
                </v-btn>
              </div>
              <div v-else class="d-flex" style="gap:8px;">
                <v-btn small color="success" :loading="salvando" @click="salvarCredenciais">
                  <v-icon left small>mdi-check</v-icon>
                  Salvar
                </v-btn>
                <v-btn small outlined @click="cancelarEdicao" :disabled="salvando">
                  <v-icon left small>mdi-close</v-icon>
                  Cancelar
                </v-btn>
              </div>
            </div>

            <v-skeleton-loader v-if="carregando" type="text@3" />

            <div v-else>
              <v-text-field
                v-for="campo in campos"
                :key="campo.key"
                :label="campo.label"
                :placeholder="modoEdicao ? campo.placeholder : undefined"
                :value="modoEdicao ? form[campo.key] : campo.mascarado"
                @input="v => { if (modoEdicao) form[campo.key] = v }"
                :readonly="!modoEdicao"
                :filled="!modoEdicao"
                outlined
                dense
                hide-details="auto"
                class="mb-3"
                autocomplete="off"
                :background-color="modoEdicao ? undefined : 'grey lighten-4'"
              />
            </div>

            <v-alert
              v-if="modoEdicao"
              type="info"
              dense
              text
              class="mb-0 mt-1"
              style="font-size:12px;"
            >
              Deixe um campo em branco para manter o valor atual.
            </v-alert>
          </v-card-text>
        </v-card>

        <!-- Sincronização -->
        <v-card flat class="mx-4 mb-4" outlined>
          <v-card-text>
            <div class="d-flex align-center justify-space-between mb-2">
              <span class="subtitle-2 text--secondary">
                <v-icon small class="mr-1" style="vertical-align:middle;">mdi-sync</v-icon>
                Sincronização de estoque
              </span>
            </div>

            <div class="d-flex align-center justify-space-between flex-wrap" style="gap:12px;">
              <div>
                <div class="body-2 font-weight-medium">Sincronização manual</div>
                <div class="caption text--secondary mt-1">Importa imediatamente os dados de estoque da Omie.</div>
              </div>
              <v-btn
                color="primary"
                :loading="sincronizando"
                :disabled="sincronizando || carregando || !config.appKeyConfigurado"
                @click="sincronizarAgora"
              >
                <v-icon left>mdi-sync</v-icon>
                Sincronizar agora
              </v-btn>
            </div>

            <v-expand-transition>
              <div v-if="sincronizando" class="mt-4">
                <v-progress-linear indeterminate color="primary" rounded height="4" class="mb-3" />
                <v-alert type="info" dense outlined class="mb-0" style="font-size:12px;">
                  Sincronização em andamento. Você será notificado quando concluir.
                </v-alert>
              </div>
            </v-expand-transition>

            <v-alert
              v-if="!config.appKeyConfigurado && !carregando"
              type="warning"
              dense
              text
              class="mb-0 mt-3"
              style="font-size:12px;"
            >
              Configure as credenciais acima para habilitar a sincronização.
            </v-alert>
          </v-card-text>
        </v-card>

      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfiguracaoOmie',
  data () {
    return {
      config: {},
      form: { appKey: '', appSecret: '', codigoLocalEstoque: '' },
      modoEdicao: false,
      salvando: false,
      sincronizando: false,
      carregando: false,
    }
  },
  computed: {
    campos () {
      return [
        { key: 'appKey', label: 'App Key', placeholder: 'Informe a app_key', senha: true, mascarado: this.config.appKeyMascarada || '—', bodyKey: 'valor' },
        { key: 'appSecret', label: 'App Secret', placeholder: 'Informe o app_secret', senha: true, mascarado: this.config.appSecretMascarada || '—', bodyKey: 'valor2' },
        { key: 'codigoLocalEstoque', label: 'Cód. Local Estoque', placeholder: 'Ex: 0', senha: false, mascarado: this.config.codigoLocalEstoque || '—', bodyKey: 'valor3' },
      ]
    }
  },
  async mounted () {
    this.$store.dispatch('set_titulo', 'Configuração Omie')
    this.getConfiguracao()
    this.sockets.subscribe('omie_sync_finalizada', () => {
      this.sincronizando = false
      this.$alertar('success', 'Sincronização finalizada', '=)')
    })
  },
  beforeDestroy () {
    this.sockets.unsubscribe('omie_sync_finalizada')
  },
  methods: {
    async getConfiguracao () {
      this.carregando = true
      try {
        const response = await this.$http.get('pdv/omie/configuracao')
        this.config = response.data
      } catch (e) {
        this.$alertar('warning', 'Erro ao carregar configuração', '=(')
      } finally {
        this.carregando = false
      }
    },
    iniciarEdicao () {
      this.form = { appKey: '', appSecret: '', codigoLocalEstoque: '' }
      this.modoEdicao = true
    },
    cancelarEdicao () {
      this.form = { appKey: '', appSecret: '', codigoLocalEstoque: '' }
      this.modoEdicao = false
    },
    async salvarCredenciais () {
      const payload = { chave: 'CONFIGURACAOOMIE', idhotel: localStorage.getItem('idhotel') }
      let algumPreenchido = false
      for (const campo of this.campos) {
        if (this.form[campo.key]) {
          payload[campo.bodyKey] = this.form[campo.key]
          algumPreenchido = true
        }
      }
      if (!algumPreenchido) {
        this.$alertar('warning', 'Preencha ao menos um campo', '=(')
        return
      }
      this.salvando = true
      try {
        await this.$http.put('pdv/updateparametros', payload)
        this.$alertar('success', 'Credenciais salvas', '=)')
        this.modoEdicao = false
        await this.getConfiguracao()
      } catch (e) {
        this.$alertar('warning', 'Erro ao salvar', '=(')
      } finally {
        this.salvando = false
      }
    },
    async sincronizarAgora () {
      this.sincronizando = true
      try {
        await this.$http.post('pdv/omie/sincronizarAgora', {})
      } catch (e) {
        this.sincronizando = false
        this.$alertar('warning', 'Erro ao iniciar sincronização', '=(')
      }
    }
  }
}
</script>
